(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    function initMobileStickyBuy(root) {
    root.querySelectorAll('[data-mobile-sticky-buy]').forEach((stickyBar) => {
      if (stickyBar.dataset.initialized === 'true') return;

      const form = stickyBar.closest('.product-form');
      const primaryButton = form && form.querySelector('.product-form__add-button');
      const stickyButton = stickyBar.querySelector('[data-sticky-add-to-cart]');

      if (!primaryButton || !stickyButton) return;

      stickyBar.dataset.initialized = 'true';

      const syncButton = () => {
        stickyButton.textContent = primaryButton.textContent.trim();
        stickyButton.disabled = primaryButton.disabled;
        stickyBar.classList.toggle('is-visible', stickyBar.classList.contains('has-passed-button') && !primaryButton.disabled);
        stickyBar.setAttribute('aria-hidden', stickyBar.classList.contains('is-visible') ? 'false' : 'true');
      };

      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        stickyBar.classList.toggle('has-passed-button', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        syncButton();
      });

      observer.observe(primaryButton);

      new MutationObserver(syncButton).observe(primaryButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      stickyButton.addEventListener('click', () => primaryButton.click());
      syncButton();
    });
  }

  document.addEventListener('DOMContentLoaded', () => initMobileStickyBuy(document));
  document.addEventListener('shopify:section:load', (event) => initMobileStickyBuy(event.target));
  } catch(e) { console.error(e); }
})();

})();
